import { Component, OnInit, ViewChild } from '@angular/core';
import { PoBreadcrumb, PoUploadComponent, PoNotificationService } from '@po-ui/ng-components';
import { CertificadoDigitalService } from './certificado-digital.service';

@Component({
  selector: 'app-certificado-digital',
  templateUrl: './certificado-digital.component.html',
  styleUrls: ['./certificado-digital.component.css'],
  standalone: false
})
export class CertificadoDigitalComponent implements OnInit {

  @ViewChild('uploadCertificado', { static: true }) uploadCertificado!: PoUploadComponent;

  urlPlaceholder = 'https://po-ui.io';

  // Campos do formulário
  senha: string = '';
  certificadoBase64: string = '';
  
  // Campos da tabela (preenchidos pela API)
  titular: string = '';
  razaoSocial: string = '';
  nomeFantasia: string = '';
  cnpj: string = '';
  emissor: string = '';
  dataEmissao: string = '';
  dataValidade: string = '';
  serial: string = '';

  isLoading: boolean = false;

  readonly breadcrumb: PoBreadcrumb = {
    items: [{ label: 'Home', link: '/home' }, { label: 'Integrações' }, { label: 'Certificado Digital' }]
  };

  constructor(
    private readonly certificadoDigitalService: CertificadoDigitalService,
    private readonly poNotificationService: PoNotificationService
  ) { }

  ngOnInit(): void {
  }

  get isBotaoHabilitado(): boolean {
    const hasFile = this.uploadCertificado?.currentFiles?.length > 0;
    const hasSenha = !!this.senha && this.senha.trim() !== '';
    return hasFile && hasSenha;
  }

  private converterParaBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result as string;
        // Remove o prefixo "data:application/octet-stream;base64," se existir
        const base64 = base64String.split(',')[1] || base64String;
        resolve(base64);
      };
      reader.onerror = (error) => {
        console.error('Erro ao converter arquivo para Base64:', error);
        reject(error);
      };
      reader.readAsDataURL(file);
    });
  }

  async enviarCertificado(): Promise<void> {
    if (!this.isBotaoHabilitado) {
      return;
    }

    const files = this.uploadCertificado?.currentFiles;
    if (!files || files.length === 0) {
      return;
    }

    const file = files[0];
    if (!file.rawFile) {
      return;
    }

    this.isLoading = true;

    try {
      this.certificadoBase64 = await this.converterParaBase64(file.rawFile);

      this.certificadoDigitalService.enviarCertificadoDigital(this.certificadoBase64, this.senha).subscribe({
        next: (response) => {
          this.isLoading = false;
          this.preencherTabela(response);
          this.poNotificationService.success('Certificado processado com sucesso!');
        },
        error: (error) => {
          this.isLoading = false;
          console.error('Erro ao enviar certificado:', error);
          if (error.error?.message) {
            this.poNotificationService.error(error.error.message);
          } else {
            this.poNotificationService.error('Erro ao processar o certificado. Por favor, tente novamente.');
          }
        }
      });
    } catch (error) {
      this.isLoading = false;
      console.error('Erro ao processar certificado:', error);
      this.poNotificationService.error('Erro ao converter o arquivo. Por favor, tente novamente.');
    }
  }

  private preencherTabela(response: any): void {
    // Preenche os campos da tabela com os dados retornados pela API
    this.titular = response.titular || response.Titular || '';
    this.razaoSocial = response.razaoSocial || response.RazaoSocial || '';
    this.nomeFantasia = response.nomeFantasia || response.NomeFantasia || '';
    this.cnpj = response.cnpj || response.CNPJ || '';
    this.emissor = response.emissor || response.Emissor || '';
    this.dataEmissao = response.dataEmissao || response.DataEmissao || '';
    this.dataValidade = response.dataValidade || response.DataValidade || '';
    this.serial = response.serial || response.Serial || response.serialNumber || response.SerialNumber || '';
  }

}

